import {
	EmailPasswordStrategy,
	KeycloakStrategy,
	type AuthStrategy,
} from "@workspace/auth-context";

const keycloakUrl =
	import.meta.env.VITE_KEYCLOACK_URL ?? "http://localhost:8080/";

// Create the available authentication strategies
export const createAuthStrategies = (): AuthStrategy[] => {
	const strategies: AuthStrategy[] = [];

	// Email/Password Strategy
	const emailPasswordStrategy = new EmailPasswordStrategy({
		loginEndpoint: "/auth/credentials",
		apiKey: undefined, // Add if needed
	});
	strategies.push(emailPasswordStrategy);

	// Keycloak Strategy (based on the realm configuration)
	const keycloakStrategy = new KeycloakStrategy({
		url: keycloakUrl,
		realm: "bookgusto",
		clientId: "bookgusto-web",
		enableLogging: import.meta.env.DEV,
		checkLoginIframe: false,
	});
	strategies.push(keycloakStrategy);

	return strategies;
};

const defaultStrategy = import.meta.env.VITE_DEFAULT_AUTH_STRATEGY
	? import.meta.env.VITE_DEFAULT_AUTH_STRATEGY
	: "email-password";

const enabledStrategies = import.meta.env.VITE_AUTH_STRATEGIES
	? import.meta.env.VITE_AUTH_STRATEGIES.split(",").map((s: string | null) =>
			s?.trim(),
		)
	: (["email-password", "keycloak"] as const);

export const authConfig = {
	strategies: createAuthStrategies(),
	defaultStrategy,
	enabledStrategies,
};

export type EnabledStrategy = (typeof authConfig.enabledStrategies)[number];
